import Vue from 'vue'
import {formatDate} from 'UTILS/date.js'
import { formatImageCdnUrl } from 'UTILS/url.js'
import {CYZSRefundStatusList} from '../config/status/CYZSRefundStatus'
import {ThirdPartRefundStatusList} from '../config/status/ThirdPartRefundStatus'

/**
 * 格式化时间
 */
Vue.filter('formatDate', (val, format) => {
  return formatDate(val, format)
})

/**
 * 格式化退款状态
 * 2017-2-15改动，所有的订单状态判断都可以通过该filter
 * 2017-2-21再次改动
 */
Vue.filter('convertRefundStatus', (status) => {
  if (typeof status !== 'number' || isNaN(parseInt(status))) {
    return ''
  }
  if (!CYZSRefundStatusList[status]) {
    return ''
  }
  return CYZSRefundStatusList[status].text
})

/**
 * 格式化第三方订单退款状态
 */
Vue.filter('convertThirdPartyRefundStatus', (status) => {
  if (typeof status !== 'number' || isNaN(parseInt(status))) {
    return ''
  }
  if (!ThirdPartRefundStatusList[status]) {
    return ''
  }
  return ThirdPartRefundStatusList[status].text
})

/**
 * 格式化订单状态
 */
Vue.filter('convertOrderStatus', (status) => {
  if (status == 1) {
    return '未付款'
  } else if (status == 2) {
    return '未发货'
  } else if (status == 4) {
    return '已发货'
  } else if (status == 8) {
    return '已收货'
  } else if (status == 16) {
    return '已完成'
  } else if (status == 32) {
    return '已取消'
  } else if (status == 128) {
    return '已评价'
  }
  return ''
})

/**
 * 格式化第三方订单错误状态
 */
Vue.filter('convertThirdPartyErrorStatus', (status) => {
  if (status == 1) {
    return '第三方登录失败'
  } else if (status == 2) {
    return '第三方地址修改失败'
  } else if (status == 3) {
    return '第三方下单失败'
  } else if (status == 4) {
    return '第三方超过48小时未发货'
  } else if (status == 5) {
    return '穿衣与第三方订单状态超过24小时不匹配'
  } else if (status == 6) {
    return '穿衣地址转第三方地址失败'
  } else if (status == 11) {
    return '第三方需要手动下单'
  }
  return ''
})

/**
 * 格式化支付方式
 */
Vue.filter('convertPaymentType', (status) => {
  if (status == 1) {
    return '支付宝'
  } else if (status == 2) {
    return '银联'
  } else if (status == 4) {
    return '微信支付'
  } else if (status == 8) {
    return '支付宝快捷支付'
  } else if (status == 16) {
    return '优惠券'
  } else if (status == 32) {
    return '微信wap支付'
  } else if (status == 64) {
    return '微信代付'
  } else if (status == 128) {
    return '招行代付'
  } else if (status == 256) {
    return '银联wap支付'
  } else if (status == 512) {
    return '京东网银在线'
  }
  return ''
})

/**
 * 格式化用户类型
 */
Vue.filter('convertUserType', (status) => {
  if (status == 2) {
    return '卖家'
  } else if (status == 1) {
    return '买家'
  }
  return ''
})

/**
 * 格式化第三方平台
 */
Vue.filter('convertPlatform', (status) => {
  if (status == 0) {
    return '穿衣助手'
  } else if (status == 1) {
    return '淘宝'
  } else if (status == 2) {
    return '天猫'
  } else if (status == 3) {
    return '蘑菇街'
  }
  return ''
})

/**
 * 上下架
 */
Vue.filter('convertSoldOut', (status) => {
  if (status == 0) {
    return '上架'
  }
  return '下架'
})

/**
 * 七牛图片
 * 指定新高度为 467px：
 */
Vue.filter('formatQiniuImageH', (url, h) => {
  if (!url) {
    return ''
  }
  if (!h) {
    return url
  }
  // ?imageMogr2/thumbnail/300x300/interlace/1
  return `${url}?imageMogr2/thumbnail/x${h}/interlace/1`
})

/**
 * 七牛图片
 * 指定新宽度为 700px
 */
Vue.filter('formatQiniuImageW', (url, w) => {
  if (!url) {
    return ''
  }
  if (!w) {
    return url
  }
  // ?imageMogr2/thumbnail/700x
  return `${url}?imageMogr2/thumbnail/${w}x/interlace/1`
})
/**
 * 七牛图片
 * 限定长边，生成不超过 300x300 的缩略图
 */
Vue.filter('formatQiniuImageMaxWAndMaxH', (url, w, h) => {
  if (!url) {
    return ''
  }
  if (!w) {
    return url
  }
  if (!h) {
    h = 4 * w / 3
  }
  // ?imageMogr2/thumbnail/300x300
  return `${url}?imageMogr2/thumbnail/${w}x${h}/interlace/1`
})
/**
 * 七牛图片
 *  限定短边，生成不小于 200x200 的缩略图
 */
Vue.filter('formatQiniuImageMinWAndMinH', (url, w, h) => {
  if (!url) {
    return ''
  }
  if (!w) {
    return url
  }
  if (!h) {
    h = 4 * w / 3
  }
  // ?imageMogr2/thumbnail/!200x200r
  return `${url}?imageMogr2/thumbnail/!${w}x${h}r/interlace/1`
})

/**
 * 七牛自定义宽
 */
Vue.filter('formatQiniuImage', (url, size, ext) => {
  if (!url) {
    return ''
  }
  if (!size) {
    return url
  }
  if (!ext) {
    ext = 'png'
  }
  return `${url}!w${size}${ext}`
})
/**
 * 处理服务器图片地址
 */
Vue.filter('formatServerImage', (url) => {
  if (!url) {
    return ''
  }
  if (url.indexOf(process.env.VUE_APP_IMGCDN) == -1) {
    return formatImageCdnUrl(process.env.VUE_APP_IMGCDN, url)
  }
  return url
})

Vue.filter('formatImageQuality', (url, quality) => {
  if (url.indexOf('imageMogr2/quality') > -1) {
    return url
  }
  return `${url}?imageMogr2/quality/${quality}`
})

/**
 * 数组<->\n字符串转换
 */

Vue.filter('formatLineFeed', {
  // model -> view
  read: function (val) {
    if (val.length == undefined) return ''
    return val.join('\n')
  },
  // view -> model
  write: function (val, oldVal) {
    return val.split('\n')
  }
})

/**
 * 去第三方平台订单详情页
 */
Vue.filter('goThirdpartyOrderDetail', (goodsId, isMogujie) => {
  if (isMogujie == 1) {
    return 'http://order.mogujie.com/order/detail4buyer?orderId=' + goodsId
  } else {
    return 'https://buyertrade.taobao.com/trade/detail/trade_item_detail.htm?bizOrderId=' + goodsId
  }
})
